import fontAwesome_solid from '@fortawesome/fontawesome-free/js/solid.min';
import fontAwesome_regular from '@fortawesome/fontawesome-free/js/regular.min';
import fontAwesome_brand from '@fortawesome/fontawesome-free/js/brands.min';
import fontAwesome from '@fortawesome/fontawesome-free/js/fontawesome.min';